import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HTMLContent } from '../../common/components/html-content';
import Popup from '../../common/components/popup';

export default function EventsMoreDetails() {
    const location = useLocation();
    const eventsDetails = location.state?.eventsDetails;
    const EventPlans = eventsDetails?.EventPlans?.[0]?.EntityInfo;
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectMembership, setSelectMembership] = useState<any>({});

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);


   

   


    return (

        <>
           
            <div className="font-sans bg-gray-50 py-12 min-h-screen">
                <div className="relative bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 py-24 text-center text-white overflow-hidden shadow-md">
                    <div className="max-w-4xl mx-auto px-4 z-10 relative">
                        <h1 className="text-5xl md:text-6xl font-extrabold drop-shadow-lg tracking-tight">
                            {eventsDetails?.Name}
                        </h1>
                        <p className="text-xl md:text-2xl font-medium mt-4 drop-shadow-sm leading-relaxed">
                            {eventsDetails?.Remarks}
                        </p>
                    </div>
                </div>

                <div className="bg-[#fff4f0] py-12 px-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 text-center">
                        <div className="flex flex-col items-center px-2">
                            <svg className="w-16 h-16 text-primary" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M2 4.5H8.75736C9.55301 4.5 10.3161 4.81607 10.8787 5.37868L14 8.5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5 13.5H2" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8.5 7.5L10.5 9.5C11.0523 10.0523 11.0523 10.9477 10.5 11.5C9.94772 12.0523 9.05229 12.0523 8.5 11.5L7 10C6.13931 10.8607 4.77671 10.9575 3.80294 10.2272L3.5 10" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5 11V15.5C5 17.3856 5 18.3284 5.58579 18.9142C6.17157 19.5 7.11438 19.5 9 19.5H18C19.8856 19.5 20.8284 19.5 21.4142 18.9142C22 18.3284 22 17.3856 22 15.5V12.5C22 10.6144 22 9.67157 21.4142 9.08579C20.8284 8.5 19.8856 8.5 18 8.5H9.5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.25 14C15.25 14.9665 14.4665 15.75 13.5 15.75C12.5335 15.75 11.75 14.9665 11.75 14C11.75 13.0335 12.5335 12.25 13.5 12.25C14.4665 12.25 15.25 13.0335 15.25 14Z" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p className="text-lg text-gray-800 mt-4 font-semibold">
                                 {eventsDetails?.EntityTypeName}
                            </p>
                        </div>
                        <div className="flex flex-col items-center px-2">
                            <svg className="w-16 h-16 text-primary" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 2V6M8 2V6" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M3 10H21" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p className="text-lg text-gray-800 mt-4 font-semibold">
                                {new Date(eventsDetails?.StartDateUtc).toLocaleDateString('en-GB')}
                            </p>
                        </div>

                        <div className="flex flex-col items-center px-2">
                            <svg className="w-16 h-16 text-primary" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 2V6M8 2V6" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M3 10H21" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897" stroke="#0b1158" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p className="text-lg text-gray-800 mt-4 font-semibold">
                                {new Date(eventsDetails?.EndDateUtc).toLocaleDateString('en-GB')}
                            </p>
                        </div>
                        <div className="flex flex-col items-center px-2">
                            <svg className="w-16 h-16 text-primary" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C7.52232 2 3.77426 4.94289 2.5 9H5" stroke="#070925" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 8V12L14 14" stroke="#070925" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 12C2 12.3373 2.0152 12.6709 2.04494 13M9 22C8.6584 21.8876 8.32471 21.7564 8 21.6078M3.20939 17C3.01655 16.6284 2.84453 16.2433 2.69497 15.8462M4.83122 19.3065C5.1369 19.6358 5.46306 19.9441 5.80755 20.2292" stroke="#070925" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p className="text-lg text-gray-800 mt-4 font-semibold">
                                Max Participants:
                                {EventPlans?.MaxParticipants}
                            </p>
                        </div>

                    </div>
                </div>


                <div className="max-w-6xl mx-auto px-6 py-20">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                        {/* Specifications */}
                        <div className="bg-white p-8 rounded-2xl shadow-lg border border-yellow-400 hover:shadow-2xl transition duration-300">
                            <div className="flex items-center gap-3 mb-4">
                                <svg className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <h3 className="text-2xl font-bold text-gray-800">Specifications</h3>
                            </div>
                            <div className="text-gray-700 leading-relaxed text-base">
                                <HTMLContent htmlContent={eventsDetails?.Specifications} />
                            </div>
                        </div>

                        {/* Services */}
                        <div className="bg-white p-8 rounded-2xl shadow-lg border border-pink-400 hover:shadow-2xl transition duration-300">
                            <div className="flex items-center gap-3 mb-4">
                                <svg className="w-6 h-6 text-pink-500" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <h3 className="text-2xl font-bold text-gray-800">Services</h3>
                            </div>
                            <div className="text-gray-700 leading-relaxed text-base">
                                <HTMLContent htmlContent={eventsDetails?.IncludedServices} />
                            </div>
                        </div>
                    </div>
                </div>



                <div className="text-center mt-12">
                  
                </div>

                <br ></br>

            </div>
        </>
    );
}


